module.exports = __webpack_public_path__ + "media/images/icons/battery-full-808313b40adf8fa5380a490ddf322e90.svg";